import { useState } from "react";
import { PromptPair, Wazawan } from "./Wazawan";
import { ExternalLink, Maximize2 } from "lucide-react";
import "./WazawanFormFillPreview.css";
import { AIFormFillResponse } from "winslow-core";
import { WazawanFileSlug } from "./WazawanFileSlug";
import { MyTooltip } from "../common/MyTooltip";

type WazawanFormFillPreviewProps = {
    promptPair: PromptPair;
    onExpand: (promptPair: PromptPair) => void;
}

export const WazawanFormFillPreview = ({promptPair, onExpand} : WazawanFormFillPreviewProps) => {
    
    const response = JSON.parse(promptPair.response) as AIFormFillResponse
    return (
        <div className="wazawan-form-fill-preview">
            
            <MyTooltip title={response.cloudURL}>
                <WazawanFileSlug fileName={response.fileName || "(untitled file)"} />
            </MyTooltip>
            <div 
                className="wazawan-form-fill-preview-expand"
                onClick={()=>onExpand(promptPair)}
            >
                <Maximize2 size={16} />
            </div>
            <div 
                className="wazawan-form-fill-preview-open"
                onClick={()=>window.open(response.cloudURL, "_blank")}
            >
                <ExternalLink size={16} />
            </div>
            {/* <div 
                className="wazawan-form-fill-preview-open"
                onClick={()=>window.open(response.cloudURL, "_blank")}
            >
                <ExternalLink size={16} />
            </div> */}

        </div>        
    )
}